import { render, staticRenderFns } from "./OAuthCallbackPage.vue?vue&type=template&id=78ea0613&"
import script from "./OAuthCallbackPage.vue?vue&type=script&lang=js&"
export * from "./OAuthCallbackPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports